export default {
  WEBSITE: 'WEBSITE',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
  LINKEDIN: 'LINKEDIN',
  INSTAGRAM: 'INSTAGRAM',
}
